import axios from "axios";
import { reactive, ref } from "vue";
import { directLoading, errors, toast, meta, loadingBtn, remove } from "./shared";

export default function useNote(navigation) {
  const { route, router } = navigation;
  const initNote = { content: "" };
  const notes = ref([]);
  const note = reactive({...initNote});
  const getNotes = async (type,id) => {
    try {
      errors.value = "";
      directLoading.value = true;
      let response = await axios.get("user/note/" + type + "/" + id );
      directLoading.value = false;
      notes.value = response.data.data;
      Object.assign(meta, response.data.meta);
    } catch (e) {
      errors.value = e;
      directLoading.value = false;
    }
  };

  const storeNote = async () => {
    try {
      errors.value = "";
      loadingBtn.value = true;
      let response = await axios.post("user/note", note);
      loadingBtn.value = false;
      notes.value.push(response.data.data);
      note.content = '';
      toast.success(response.data.message);
    } catch (e) {
      window.networkError(e);
      loadingBtn.value = false;
    }
  };

  const updateNote = async () => {
    try {
      errors.value = "";
      progressDialog.value = true;
      let response = await axios.put(
        "user/note/" + note.id,
        saveMessage
      );
      const index = notes.value.findIndex(
        (item) => item.id === note.id
      );
      notes.value[index] = response.data.data;
      progressDialog.value = false;
      toast.success(response.data.message);
    } catch (e) {
      window.networkError(e);
      progressDialog.value = false;
    }
  };

  const removeNote = async () => {
    try {
      loadingBtn.value = true;
      let response = await axios.delete("user/note/" + note.id);
      toast.success(response.data.message);
      loadingBtn.value = false;
    } catch (e) {
      window.networkError(e);
      loadingBtn.value = false;
    }
  };

  const clearNote = () => initObject(note,initNote);

  return {
    notes,
    note,
    getNotes,
    clearNote,
    storeNote,
    updateNote,
    removeNote,
  };
}
